<template>
  <section class="c-company app-bg" v-if="value && value.name &&this.value.name.indexOf('美亚') == -1">
    <v-layout class="header" justify-center>
      <h4>保险公司介绍</h4>
    </v-layout>
    <v-layout class="mt-4" justify-center>
      <img class="company-logo" :src="value.logo" alt="保险公司logo">
    </v-layout>
    <p class="subheading text-xs-center mt-1">{{ value.name }}</p>
    <div class="introduce-text" v-html="value.introduction"></div>
  </section>
</template>

<script>
export default {
  props: {
    value: Object
  },
  data() {
    return {
      // 这些产品的 logo 大小不设置
      excludes: ["诚泰财产保险股份有限公司"]
    };
  }
};
</script>

<style lang="scss" scoped>
.c-company {
  padding: 0 30px 41px 30px;
  .header {
    height: 60px;
    line-height: 60px;
    border-bottom: 1px solid #eaeff2;
  }
  .company-logo {
    width: auto;
    max-height: 51px;
  }
}
</style>

